import helpers from './helpers';

const DEVELOPERSPACE_BRANDINGS = ['developerspace', 'developerspace_internal'];

export default {
  typeFromQuery: query => helpers.parseQueryString(query).idpType,
  vhostlessFromQuery: query => helpers.parseQueryString(query).vhostless === 'true',
  isDeveloperSpaceBranding: query => DEVELOPERSPACE_BRANDINGS.includes(helpers.parseQueryString(query).branding),
  developerSpaceRedirectUrl: (query) => {
    const branding = helpers.parseQueryString(query).branding;
    const base = process.env.PARTNER_PORTAL_FRONTEND_BASE;
    return branding === 'developerspace_internal' ? `${base}/internal` : base;
  },
  authCodeClientId: (idpType) => {
    let clientId;
    switch (idpType) {
      case 'property':
        clientId = process.env.AUTH_CODE_PROPERTY_CLIENT_ID;
        break;
      case 'tportal':
        clientId = process.env.AUTH_CODE_TPORTAL_CLIENT_ID;
        break;
      default:
        throw new Error(`Unsupported idpType: ${idpType}`);
    }

    return clientId;
  },
};
